<template>
  <div class="post type-post hentry">
    <h2>
      <router-link to="/2010/12/sutuoktiniu-gyvenimas-skyrium-separacija/"
        >Sutuoktinių gyvenimas skyrium (separacija)</router-link
      >
    </h2>
    <div class="comm_date">
      <span class="month">Gruodžio</span><span class="date_nr">28</span>
    </div>
    <div class="entry">
      <p>
        Kalbantis liūdna skyrybų tema, kartais užsimenama apie naują terminą
        mūsų teisiniame leksikone – gyvenimą skyrium (separaciją). LR
        Civiliniame kodekse numatyta, kad sutuoktiniai, oficialiai nenutraukę
        santuokos, gali gyventi savo atskirus gyvenimus, oficialiai atsiriboję
        vienas nuo kito savo teises ir pareigas, nevesdami bendro ūkio,
        neturėdami ir nesukurdami bendrosios jungtinės nuosavybės. Gyvenimo
        skyrium (separacijos) teisinė būsena, arba toks teisinis sutuoktinių
        tarpusavio santykių statusas nustatomas teisme. Bet kuris sutuoktinis
        šiuo reikalu gali kreiptis į teismą, jeigu dėl kokių nors aplinkybių,
        nors ir nepriklausančių nuo kito sutuoktinio, bendras jų gyvenimas tapo
        netoleruotinu arba gali pakenkti jų nepilnamečių vaikų interesams, arba
        sutuoktiniai nesuinteresuoti tęsti bendrą gyvenimą. Jeigu bendru prašymu
        į teismą dėl gyvenimo skyrium patvirtinimo kreipiasi abu sutuoktiniai,
        ir jie yra sudarę sutartį, kurioje numato nepilnamečių vaikų
        gyvenamosios vietos, jų išlaikymo ir auklėjimo, taip pat sutuoktinių
        turto ir skolų pasidalijimo bei tarpusavio išlaikymo klausimus, teismo
        procesas žymiai supaprastėja.
      </p>
      <p>
        Sutuoktinis, prieš kurį yra prašymas dėl separacijos, gali paduoti
        priešinį reikalavimą dėl santuokos nutraukimo, ir sutuoktinis, kuriam
        iškelta byla dėl santuokos nutraukimo, gali reikšti priešinį reikalavimą
        dėl gyvenimo skyrium. Jeigu vienas sutuoktinis prašo santuoką nutraukti,
        o kitas – patvirtinti separaciją, teismas gali išspręsti ginčą bet kurio
        naudai, priklausomai nuo aplinkybių.
      </p>
      <p>
        Gali būti skiriamas iki 6 mėn. trukmės susitaikymo laikas, ir jo metu
        nustatytos laikinosios apsaugos priemonės: vaikų gyvenamosios vietos
        nustatymas, turto areštas, draudimas matytis su vaikais arba lankytis
        tam tikrose vietose ir t.t.
      </p>
      <p>
        Teismas, patvirtindamas gyvenimą skyrium, nustato, su kuo gyvens
        nepilnamečiai vaikai, kas juos išlaikys ir kaip tėvai dalyvaus
        nepilnamečių auklėjime. Sprendžiant, kam iš sutuoktinių liks teisė
        gyventi šeimos gyvenamojoje patalpoje, pirmenybė turi būti teikiama tam,
        su kuriuo lieka nepilnamečiai vaikai arba kuris yra nedarbingas.
        Bylinėjimosi supaprastinimui patartina pateikti teismui bendrą
        pareiškimą ir sutartį dėl gyvenimo skyrium pasekmių, kurioje reiktų
        laikytis analogiškų principų, kaip ir santuoką nutraukiant bendru
        sutarimu, suminėtų LR CK 3.53 str. 3 d.
      </p>
      <p>
        Patvirtinus gyvenimą skyrium, sutuoktinių bendras gyvenimas baigiasi,
        bet išlieka kitos jų teisės ir pareigos, pvz.: teisės ir pareigos
        nepilnamečiams vaikams, teisės ir pareigos išlaikyti vienas kitą ir dar
        kai kurios specifinės prievolės. Tačiau, kaip nurodo LR CK 3.77 str. 3
        d., priimdamas sprendimą dėl sutuoktinių gyvenimo skyrium, teismas
        visais atvejais privalo išspręsti sutuoktinių bendro turto padalijimo
        klausimus. Besiskiriantys dažnai pageidauja skyrybų procedūrą užbaigti
        kuo skubiau. Teismai tiek separacijos, tiek ir santuokos nutraukimo
        bylose į tokį įsakmų įstatymo reikalavimą kartais pažiūri liberaliai ir
        nepagrįstai palieka turto padalijimo klausimą neišspręstą. Toks
        sprendimas buvusiems sutuoktiniams suteikia dvasios ir kūno laisvę,
        tačiau ateičiai palieka užslėptas žabangas ir kliūtis, į kurias
        disponuojant bendrąja santuokoje įgyta nuosavybe, jie anksčiau ar vėliau
        pateks. Ir nors turtas įregistruotas tik vieno kurio nors sutuoktinio
        vardu, tačiau atliekant bet kokio nekilnojamojo arba kito turto, kuriam
        reikalinga privalomoji registracija sandorius (žemės ar miško sklypų,
        vandens telkinių, statinių, įmonių, transporto priemonių, pajų, akcijų,
        hipotekos, indėlių ir sąskaitų ir kt.), visais atvejais bus reikalaujama
        pateikti teismo sprendimą apie pasidalijimą, arba sandorio sudaryme
        privalės dalyvauti buvusysis sutuoktinis, kadangi teisiškai jis yra
        paliktas bendraturčiu (bendrasavininkiu).
      </p>
      <p>
        Patartina iki bylos turtą taikiai pasidalinti rašytine sutartimi ir
        pasitvirtinti pas notarą, taip sutaupant laiko ir pinigų. (Teismo
        žyminis mokestis – 3% nuo pasidalijamo turto vertės, o notaro rinkliava
        – ne daugiau 1%). Sutuoktiniams, atnaujinus bendrą gyvenimą, t.y.
        nutraukus separaciją, jų turtas lieka atskirtas, kol jie oficialiai
        nesusitars kitaip. Pažymėtina, kad gyvenimas skyrium ilgiau kaip 1 metus
        yra viena iš būtinųjų sąlygų, kuriai esant bet kuris sutuoktinis turi
        teisę reikalauti santuoką nutraukti pagal LR CK 3.55 str. (Santuokos
        nutraukimas vieno sutuoktinio prašymu).
      </p>
    </div>
  </div>
</template>
